import { render, staticRenderFns } from "./RelatedPosts.vue?vue&type=template&id=15fba966"
import script from "./RelatedPosts.vue?vue&type=script&lang=js"
export * from "./RelatedPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports